import { render, staticRenderFns } from "./ptcview.vue?vue&type=template&id=7ad31c85&scoped=true&"
import script from "./ptcview.vue?vue&type=script&lang=js&"
export * from "./ptcview.vue?vue&type=script&lang=js&"
import style0 from "./ptcview.vue?vue&type=style&index=0&id=7ad31c85&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad31c85",
  null
  
)

export default component.exports